























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'

@Component({})
export default class Alert extends Vue {
  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly value!: boolean

  public visible = false

  public dismiss() {
    this.visible = false
    this.$emit('input', this.visible)
  }

  @Watch('value')
  public onValueChanged(value: boolean) {
    this.visible = value
  }
}
